import { render, staticRenderFns } from "./gg.vue?vue&type=template&id=0ecd3790&scoped=true"
import script from "./gg.vue?vue&type=script&lang=js"
export * from "./gg.vue?vue&type=script&lang=js"
import style0 from "./gg.vue?vue&type=style&index=0&id=0ecd3790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecd3790",
  null
  
)

export default component.exports